function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "45.667px",
    height: "30.831px",
    viewBox: "0 0 45.667 30.831",
    style: {
      enableBackground: "new 0 0 45.667 30.831"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 36.4663,
    y1: -9.7959,
    x2: -1.5386,
    y2: 28.209
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#31C2DD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B9BD7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M23.168,7c-0.829,0-1.5-0.672-1.5-1.5v-4c0-0.828,0.671-1.5,1.5-1.5 c0.828,0,1.5,0.672,1.5,1.5v4C24.668,6.328,23.997,7,23.168,7L23.168,7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 32.8628,
    y1: -13.397,
    x2: -5.1398,
    y2: 24.6056
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#31C2DD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B9BD7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_2_)"
    },
    d: "M14.512,9.186c-0.519,0-1.022-0.269-1.3-0.75l-2-3.463 c-0.415-0.717-0.169-1.635,0.549-2.049c0.717-0.414,1.635-0.168,2.049,0.549l2,3.463c0.415,0.717,0.169,1.635-0.549,2.049 C15.024,9.121,14.766,9.186,14.512,9.186L14.512,9.186z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 32.7729,
    y1: -13.4912,
    x2: -5.2345,
    y2: 24.5162
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#31C2DD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B9BD7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_3_)"
    },
    d: "M8.104,15.408c-0.254,0-0.512-0.064-0.749-0.201l-3.464-2 c-0.717-0.414-0.963-1.332-0.549-2.049c0.415-0.717,1.332-0.964,2.049-0.549l3.464,2c0.717,0.414,0.963,1.332,0.549,2.049 C9.126,15.14,8.622,15.408,8.104,15.408L8.104,15.408z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 36.2163,
    y1: -10.0464,
    x2: -1.7898,
    y2: 27.9597
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#31C2DD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B9BD7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_4_)"
    },
    d: "M5.669,24h-4c-0.829,0-1.5-0.672-1.5-1.5s0.671-1.5,1.5-1.5h4c0.829,0,1.5,0.672,1.5,1.5 S6.498,24,5.669,24L5.669,24z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 55.7153,
    y1: 9.4517,
    x2: 17.7084,
    y2: 47.4585
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#31C2DD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B9BD7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_5_)"
    },
    d: "M44.167,24.498h-3.999c-0.829,0-1.5-0.672-1.5-1.5s0.671-1.5,1.5-1.5h3.999 c0.828,0,1.5,0.672,1.5,1.5S44.995,24.498,44.167,24.498L44.167,24.498z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 49.2134,
    y1: 2.9507,
    x2: 11.2071,
    y2: 40.957
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#31C2DD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B9BD7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_6_)"
    },
    d: "M44.167,30.831H1.5c-0.829,0-1.5-0.671-1.5-1.5s0.671-1.5,1.5-1.5h42.667 c0.828,0,1.5,0.671,1.5,1.5S44.995,30.831,44.167,30.831L44.167,30.831z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 49.6577,
    y1: 3.3955,
    x2: 11.6531,
    y2: 41.4002
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#31C2DD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B9BD7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_7_)"
    },
    d: "M37.981,15.84c-0.518,0-1.022-0.27-1.301-0.75c-0.414-0.718-0.168-1.635,0.55-2.049l3.464-2 c0.719-0.414,1.635-0.166,2.049,0.55c0.414,0.718,0.168,1.636-0.549,2.05l-3.464,1.998C38.494,15.775,38.236,15.84,37.981,15.84 L37.981,15.84z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 42.6128,
    y1: -3.6509,
    x2: 4.6063,
    y2: 34.3556
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#31C2DD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B9BD7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_8_)"
    },
    d: "M31.756,9.436c-0.255,0-0.513-0.064-0.749-0.201c-0.718-0.414-0.964-1.332-0.549-2.049 l2-3.463c0.415-0.717,1.332-0.964,2.049-0.549c0.718,0.414,0.964,1.332,0.549,2.049l-2,3.463 C32.778,9.167,32.274,9.436,31.756,9.436L31.756,9.436z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 45.0532,
    y1: -1.2095,
    x2: 7.0471,
    y2: 36.7966
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#31C2DD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B9BD7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_9_)"
    },
    d: "M14.815,24.27c-0.093-0.494-0.146-1-0.146-1.52c0-4.549,3.701-8.25,8.25-8.25 s8.25,3.701,8.25,8.25c0,0.52-0.054,1.025-0.146,1.52h4.042c0.062-0.5,0.104-1.004,0.104-1.52c0-6.755-5.495-12.25-12.25-12.25 s-12.25,5.495-12.25,12.25c0,0.516,0.042,1.02,0.104,1.52H14.815z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon-1.29d2a4f78ce119bb3ac5329e2d9bd6a8.svg";
export { ForwardRef as ReactComponent };